<template>
  <img src="@/assets/img/Icons/gallery/grey-dot.svg" />
</template>

<script>
export default {}
</script>

<style></style>
